import r from"./_baseGetTag.js";import t from"./isObjectLike.js";var e=r,o=t;var a=function(r){return o(r)&&"[object Arguments]"==e(r)};export{a as default};
//# sourceMappingURL=_baseIsArguments.js.map
